@if (queryItem?.isStats) {
  <div class="stats-content">
    @if (isSimpleStatsView$ | async) {
      <div class="stats-container">
        @for (
          statsItem of queryItem?.statsData;
          track statsItem;
          let i = $index
        ) {
          <div class="stat-item">
            <atlas-simple-stats-page
              [value]="statsItem.value"
              [name]="statsItem.name"
            ></atlas-simple-stats-page>
          </div>
        }
      </div>
    } @else {
      <div class="stats-content">
        <atlas-standard-stats-page
          [queryItem]="queryItem?.statsData"
        ></atlas-standard-stats-page>
      </div>
    }
  </div>
}
